import {useMemo} from "react"
import {useTranslation} from "react-i18next"
import axios from "axios"
import {useForm} from "react-hook-form"
import {useSessionContext} from "../../reactContext/contextCustomHooks/useSessionContext"
import {useEcpProjectsContext} from "../../reactContext/contextCustomHooks/useEcpProjectsContext"
import {useEcpWorkflowContext} from "../../reactContext/contextCustomHooks/useEcpWorkflowContext"
import LoadingComponent from "../../components/loading-component/LoadingComponent"
import useEcpGlossary from "../../swrCustomHooks/useEcpGlossary"
import {API_ECP_PROJECTS} from "../../constants/apiUrls"
import {toast} from "react-toastify"
import SortGlossary from "../../tools/SortGlossary"

export default function UpdateGlossaryTermModalForm({closeModal}) {
    const {t} = useTranslation()
    const {sessionContext} = useSessionContext()
    const {ecpProjectsContext} = useEcpProjectsContext()
    const {ecpWorkflowContext} = useEcpWorkflowContext()
    const {ecpGlossary, mutateEcpGlossary,  isLoadingEcpGlossary, isErrorEcpGlossary} = useEcpGlossary(ecpProjectsContext.projectID)
    const {register, handleSubmit, setValue, formState: {isDirty, errors}} = useForm({defaultValues: useMemo(() => {
        return ecpGlossary.glossary[ecpWorkflowContext.isGlossaryModal.index]
    }, [])})

    const updateConcept = (data) => {
        const headersRequest = {headers: {Authorization: `Bearer ${sessionContext.idToken}`}}
        let terms = ecpGlossary.glossary
        terms[ecpWorkflowContext.isGlossaryModal.index] = data
        axios.put(`${API_ECP_PROJECTS}/${ecpProjectsContext.projectID}/glossary`, {glossary: SortGlossary(terms)}, headersRequest)
        .then(() => {
            mutateEcpGlossary()
            closeModal()
            toast.success(t("Term updated!"))
        })
        .catch((error) => {
            console.error(`PUT ${API_ECP_PROJECTS}/${ecpProjectsContext.projectID}/glossary :` , error)
            toast.error(t("An error has occurred"))
        })
    }

    if (isErrorEcpGlossary || isLoadingEcpGlossary || ecpGlossary.message) return <LoadingComponent/>
    return (
        <>
        <form className="glossary-modal-form" onSubmit={handleSubmit(updateConcept)}>
            <div className="fields">
                <input type="text" id="term-concept" name="term-concept" placeholder={t("Concept")} {...register("concept", {required: true})}/>
                <textarea type="text" id="term-definition" name="term-definition" placeholder={t("Definition")} {...register("definition", {required: true})}/>
            </div>
            <div className="actions">
                <button className="cancel-btn" onClick={closeModal}>{t("Cancel")}</button>
                <button className="update-btn" disabled={!isDirty}>{t("Update")}</button>
            </div>
        </form>
        </>
    )
}